import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import LeftSection from '../components/leftSection';
import RightSection from '../components/rightSection';
import { fetchNewLeads, fetchNewAccounts, fetchLatestObject, fetchLatestActivity, setTagValue, fetchTodayNewTotal } from '../flow/action';
import styles from '../index.less';
import { setRouteInfo } from '../../../components/page/TaskDetails/flow/actions';


const cx = classNames.bind(styles);

class Dashboard extends Component {
  componentDidMount() {
    const {
      fetchNewLeads,
      fetchNewAccounts,
      fetchLatestObject,
      fetchLatestActivity,
      fetchTodayNewTotal,
    } = this.props;
    fetchNewLeads();
    fetchNewAccounts();
    fetchLatestObject();
    fetchLatestActivity();
    fetchTodayNewTotal();
  }
  render() {
    const {
      leads, accounts, objects, activities, taskStatus, setRouteInfo, setTagValue, tagView, todayNewTotal,
    } = this.props;
    return (
      <div className={cx('dashboard-wrapper')}>
        <div className={cx('leftSection-wrapper')}>
          <LeftSection
            leads={leads}
            accounts={accounts}
            objects={objects}
            activities={activities}
            taskStatus={taskStatus}
            setRouteInfo={setRouteInfo}
            setTagValue={setTagValue}
            tagView={tagView}
            todayNewTotal={todayNewTotal}
          />
        </div>
        <div className={cx('right-section-wrapper')}>
          <RightSection />
        </div>
      </div>


    );
  }
}
const mapStateToProps = ({ dashboard, global }) => ({
  ...dashboard,
  taskStatus: global.settings.statuses,

});
const mapDispatchToProps = {
  fetchNewLeads,
  fetchNewAccounts,
  fetchLatestObject,
  fetchLatestActivity,
  setRouteInfo,
  setTagValue,
  fetchTodayNewTotal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/container/index.jsx